import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 
import { useQuery, useQueryClient } from '@tanstack/react-query';
import API_URL from './api/config';

function SignupTribe() {
    const navigate = useNavigate();
   
    const { data: tribeImages = [], isLoading, isError } = useQuery({
        queryKey: ['tribeImages'],
        queryFn: () =>
          axios.get(`${API_URL}/reg-signup-tribe-images-api`).then((res) => {
            if (res.data.Status === "Success") {
              return res.data.images;
            } else {
              throw new Error(res.data.Message || "Failed to fetch tribe images");
            }
          }),
        staleTime: 0,
        cacheTime: Infinity,
      });

      const {
        data: tribeCaptions = [],
        isLoading: captionLoading,
        isError: captionError,
      } = useQuery({
        queryKey: ['tribeCaptions'],
        queryFn: () =>
          axios.get(`${API_URL}/reg-signup-tribe-caption-api`).then((res) => {
            if (res.data.Status === "Success") return res.data.captions;
            else throw new Error("Caption fetch failed");
          }),
        staleTime: 0,
        cacheTime: Infinity,
      });
    
      const [selectedTribe, setSelectedTribe] = useState("");
      const { data: tribes = [], isLoading: tribeLoading } = useQuery({
        queryKey: ['tribes'],
        queryFn: () =>
            axios.get(`${API_URL}/reg-signup-tribes-api`, { withCredentials: true }).then(res => {
                if (res.data.Status === "Success") return res.data.tribes;
                throw new Error("No tribes found");
            }),
    });

    const [selectText, setSelectText] = useState("");
    useEffect(() => {
        const fetchUserInfo = async () => {
            try {
                const res = await axios.get(`${API_URL}/reg-signup-tribe-select-text-api`, { withCredentials: true });
                if (res.data.Status === "Success") {
                    setSelectText(res.data.selectText);
                }
            } catch (error) {
                console.error("Error fetching tribe select label:", error);
            }
        };
    
        fetchUserInfo();
    }, []);


    const [isSubmitting, setIsSubmitting] = useState(false);
    const handleTribeSubmit = async () => {
        if (!selectedTribe) {
          toast.error("Please select a tribe first.");
          return;
        }
      
        setIsSubmitting(true); // disable button
      
        try {
          const res = await axios.post(
            `${API_URL}/reg-signup-tribe-update-api`, 
            { tribe_id: selectedTribe },
            { withCredentials: true }
          );
      
          if (res.data.Status === "Success") {
            navigate(res.data.redirect);
          } else {
            toast.error("Failed to update tribe.");
          }
        } catch (error) {
          console.error("Tribe update failed:", error);
          toast.error("Something went wrong.");
        } finally {
          setIsSubmitting(false); // re-enable button
        }
      };


    return (
        <div className=" text-whitex ">
            <div id="page">
            <ToastContainer />
            <div className="page-content pb-0">
            <div data-card-height="cover" className=" text-center">
                    
            {isLoading ? (
              <p>Loading...</p>
            ) : tribeImages.length > 0 ? (
              tribeImages.map((img, idx) => (
                <img
                  key={idx}
                  src={`${API_URL}/images/${img.image_name}`}
                  alt="Tribe"
                  style={{ width: '100%' }}
                  className="img-signup1"
                />
              ))
            ) : (
              <p>No tribe image found.</p>
            )}
                    <div class="card-bottom card_bottom">
                    <p class="caption_text" >

                        {captionLoading ? 'Loading caption...' : (
                    tribeCaptions.map((caption, index) => (
                        <span key={index}>{caption.caption}</span>
                    ))
                    )}
                    </p>
                        <div className='row'>

                        <label className="form-label text-center">{selectText}</label>


                            <div className='col-3 col-md-3'>
                            <Link onClick={() => navigate(-1)} class="btn btn-primary">
                                                            &emsp;<i class="fa fa-arrow-left btn_arrow"></i>&emsp;</Link>
                            </div>
                            <div className='col-6 col-md-6'>

                            <select className="form-select"
                                    value={selectedTribe}
                                    onChange={(e) => setSelectedTribe(e.target.value)}
                                >
                                    <option value="">Select Tribe</option>
                                    {tribeLoading ? (
                                        <option disabled>Loading tribes...</option>
                                    ) : (
                                        tribes.map((tribe) => (
                                            <option key={tribe.id} value={tribe.id}>
                                                {tribe.tribe_name}
                                            </option>
                                        ))
                                    )}
                                </select>


                            </div>

                            <div className='col-3 col-md-3'>
                            <button onClick={handleTribeSubmit} className="btn btn-primary" type="submit"
                            disabled={isSubmitting}>
                                &emsp;<i className="fa fa-arrow-right btn_arrow"></i>&emsp;</button>

                            </div>
                        </div>
                        
                    </div>
                    

                </div>
            </div>
        </div>
        </div>
    );
}

export default SignupTribe;
